import { Controller } from 'stimulus'

export default class extends Controller {

  show() {
    document.getElementById(this.element.dataset.id).classList.remove('dn')
  }

  close() {
    document.getElementById(this.element.dataset.id).classList.add('dn')
  }
}
